import Button from "Components/button";
import classNames from "classnames";
import React from "react";
export const SIZES = {
    BUTTON_SIZE: 40,
    BUTTON_COLUMN_WIDTH: 50
};
const buttonElementAttr = {
    style: {
        position: "absolute",
        top: 0,
        right: `-${SIZES.BUTTON_COLUMN_WIDTH}px`
    }
};
export default function withDelete(WrappedComponent) {
    function Hoc({ className, deleteButtonClassName, onDelete, ...other }) {
        return (React.createElement("div", { className: classNames("position-relative", className) },
            React.createElement(WrappedComponent, { ...other }),
            React.createElement(Button, { disabled: other.disabled, className: deleteButtonClassName, width: SIZES.BUTTON_SIZE, height: SIZES.BUTTON_SIZE, elementAttr: buttonElementAttr, onClick: onDelete },
                React.createElement("i", { className: "icon-trash font-h5" }))));
    }
    return Hoc;
}
